export function createFeedbackController({ document }) {
  let region = document.querySelector("#accountFeedback");
  if (!region) {
    region = document.createElement("div");
    region.id = "accountFeedback";
    region.className = "account-feedback";
    region.setAttribute("role", "status");
    region.setAttribute("aria-live", "polite");
    region.setAttribute("aria-atomic", "true");
    document.body.append(region);
  }
  let generation = 0;

  return {
    announce(message, { undo = null } = {}) {
      generation += 1;
      const current = generation;
      region.replaceChildren(document.createTextNode(message));
      region.hidden = !message;
      if (!undo) return;
      const button = document.createElement("button");
      button.type = "button";
      button.dataset.feedbackUndo = "";
      button.textContent = "Undo";
      button.addEventListener("click", async () => {
        if (current !== generation) return;
        generation += 1;
        button.remove();
        await undo();
      }, { once: true });
      region.append(" ", button);
    },
    clear() {
      generation += 1;
      region.replaceChildren();
      region.hidden = true;
    },
  };
}
